import { render } from "./Cartera-App.vue?vue&type=template&id=caabbe82&scoped=true"
import script from "./Cartera-App.vue?vue&type=script&lang=js"
export * from "./Cartera-App.vue?vue&type=script&lang=js"

import "./Cartera-App.vue?vue&type=style&index=0&id=caabbe82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caabbe82"]])

export default __exports__